import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-nav-17",
  "use": "icon-icon-nav-17-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-nav-17\"><path d=\"M511.68 747.072L264.32 554.88l-54.4 42.24L512 832l302.08-234.88-54.72-42.688-247.68 192.64zM512 661.824l247.04-192.256 55.04-42.624L512 192 209.92 426.88l54.72 42.688L512 661.76z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-nav-17.svg
// module id = M9xu
// module chunks = 3